import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import ProviderRealtimeDashboard from "./ProviderRealtimeDashboard"
import DashboardTableTabs from "./DashboardTableTabs"
import { fetchProviderRealtimeDashboardConfig } from "store/provider-dashboard/provider-dashboard-action"

const ProviderDashboardComponent = ({
  provIpsStock,
  onCategoryChange,
  onProviderIPsAdvancedSearchHandler,
  onProviderIPsStockExport,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchProviderRealtimeDashboardConfig({}))
  }, [dispatch])

  return (
    <div className="provider-dashboard-page">
      <ProviderRealtimeDashboard />
      <div className="provider-dashboard-tables-section">
        <DashboardTableTabs
          provIpsStock={provIpsStock}
          onCategoryChange={onCategoryChange}
          onProviderIPsAdvancedSearchHandler={
            onProviderIPsAdvancedSearchHandler
          }
          onProviderIPsStockExport={onProviderIPsStockExport}
        />
      </div>
    </div>
  )
}

export default ProviderDashboardComponent
